import 'dayjs/locale/ko';

import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { usePostAnnualFeePaidApi } from '@/api/payment';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import PaymentModal from '@/components/common/Modal/PaymentModal/PaymentModal';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import { CONF_TITLE } from '@/constants/menu';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';

import * as S from './style';

const SocietyRegister = () => {
	dayjs.locale('ko');
	const START_DATE = '2026-11-04T00:00:00+09:00'; // 사전 등록 시작일
	/** 마지막 접수일(표기·환불 안내용) */
	const END_DATE = '2026-11-20T00:00:00+09:00';
	/** 11/20 하루 종일 접수: KST 11/21 0시부터 마감 */
	const REGISTRATION_CLOSE_AT = '2026-11-21T00:00:00+09:00';
	const CURRENT_DATE = '2026-11-27T00:00:00+09:00'; // 학회 당일

	const { showModal, closeModal } = useModalStore();
	const { isLogin } = useTokenStore();
	const [isOpen, setIsOpen] = useState(false);
	const [memberType, setMemberType] = useState('');
	const navigate = useNavigate();
	const location = useLocation();
	const params = location.state?.menu ?? '학술행사 안내';
	const { mutateAsync: annualFeePaid } = usePostAnnualFeePaidApi();

	// 사전 등록 기간 검증 함수
	const validateRegistrationPeriod = () => {
		// ISO 문자열의 +09:00 오프셋을 기준으로 직접 비교해, 사용자 기기 시간대와 무관하게 KST 마감 시각을 적용한다.
		const now = Date.now();
		const startDate = new Date(START_DATE); // 사전 등록 시작일
		const closeAt = new Date(REGISTRATION_CLOSE_AT);

		if (now < startDate.getTime()) {
			showModal('사전 등록 기간이 아닙니다.', 'confirm');
			return false;
		}

		if (now >= closeAt.getTime()) {
			showModal('사전 등록 기간이 종료되었습니다.', 'confirm');
			return false;
		}

		return true;
	};

	const handleRegister = async () => {
		if (!validateRegistrationPeriod()) {
			return;
		}

		if (!isLogin()) {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}

		const res = await annualFeePaid({
			goods_name: CONF_TITLE,
		});
		if (res.data.success) {
			setMemberType(res.data?.data?.member_type);

			setIsOpen(true);
		} else {
			if (res.data?.error.code === '80') {
				showModal('학회등록비 납부를\n이미 완료하셨습니다.', 'login', '확인', closeModal);
			} else {
				showModal('오류가 발생했습니다. 다시 시도해주세요.', 'register');
			}
		}
	};

	const handleConfirm = () => {
		if (isLogin()) {
			console.log('params:', params);
			navigate('/society', { state: { step: '등록 확인', menu: params } });
		} else {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>기본정보</S.ContentTitle>
				<S.BasicInfoButtonBox>
					<S.BlueButton type="button" onClick={handleRegister}>
						결제
						<SingleArrowNext iconColor="#FFFFFF" width="20" height="20" />
					</S.BlueButton>
					<S.WhiteButton type="button" onClick={handleConfirm}>
						등록 확인
						<SingleArrowNext iconColor="#12539E" width="20" height="20" />
					</S.WhiteButton>
				</S.BasicInfoButtonBox>
				<S.ContentDescription>
					<li>
						사전등록 기한 :{dayjs(START_DATE).format('YYYY년 M월 DD일 (dd)')} ~ {dayjs(END_DATE).format('YYYY년 M월 DD일 (dd)')} 까지
					</li>
					<li>참가비는 학회 홈페이지 내 카드결제(개인별로 각 건별 진행) or 계좌이체 가능</li>
					<li>
						사전등록 기한 내 결제창이 open 되어, 결제할 수 있습니다.
						<br />
						★현장 결제({dayjs(CURRENT_DATE).format('M월 D일')} 학회 당일) 참가를 진행하시는 경우 현금만 결제가 가능합니다.★
					</li>
					<li>
						참석불가로 환불이 필요하신경우 {dayjs(END_DATE).format('M월 D일 (dd)')}까지 사무국으로 연락주시기 바랍니다.
						<br />
						{dayjs(END_DATE).format('M월 D일 (dd)')} 이후 환불불가!!!!
					</li>
				</S.ContentDescription>
			</S.ContentBox>
			<S.ContentBox>
				<S.ContentBox>
					<S.ContentTitle>회비 및 참가비 안내</S.ContentTitle>
					<S.Table>
						<S.TableHeadCell className="item2 center">구분</S.TableHeadCell>
						<S.TableHeadCell className="center">학술대회 참가비</S.TableHeadCell>

						<S.TableCell className="item3 point center">회원종류</S.TableCell>
						<S.TableCell className="min-height point center">회원</S.TableCell>
						<S.TableCell className="min-height center">200,000원</S.TableCell>

						<S.TableCell className="min-height point center">학생회원</S.TableCell>
						<S.TableCell className="min-height center">100,000원</S.TableCell>
					</S.Table>
				</S.ContentBox>
			</S.ContentBox>
			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<PaymentModal closeModal={setIsOpen} goodsName="등록비" memberType={memberType} />
					</ModalBox>
				</ModalPortal>
			)}
		</S.Container>
	);
};

export default SocietyRegister;
